const customStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused ? "#B04708" : "#ced4da",
        boxShadow: state.isFocused
            ? "0 0 0 1px #B04708"
            : base.boxShadow,
        outline: "none",
        "&:hover": {
            borderColor: state.isFocused ? "#B04708" : "#adadad",
        },
    }),

    groupHeading: (base) => ({
        ...base,
        fontWeight: "bold",
        fontSize: "14px",
        color: "#B04708",
        backgroundColor: "#ffeadeff",
        padding: "8px 12px",
    }),

    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? "#B04708"
            : state.isFocused && !state.isDisabled
                ? "#fff2f0ff"
                : "white",
        color: state.isDisabled
            ? "#aaa"
            : state.isSelected
                ? "white"
                : "#333",
        opacity: state.isDisabled ? 0.6 : 1,
        cursor: state.isDisabled ? "not-allowed" : "default",
    }),
};

export default customStyles;